import React, { FC } from 'react'
import { FOOTER_LINKS, REQUEST_SUPPORT_URL, STUDIO_FOOTER_LINKS } from '../FooterData'
import SALink from 'components/SALink'
import styles from './Links.module.scss'
import classNames from 'classnames'
import GiftCardIcon from 'svg/gift-card-icon.svg'
import RequestSupportModal from 'components/Footer/RequestSupportModal'

export const ICONS_MAP = {
  ['gift-card']: <GiftCardIcon fill='#ffffff' />,
}

type FooterLinksProps = {
  isStudio?: boolean
}

const FooterLinks: FC<FooterLinksProps> = ({ isStudio }) => {
  const links = isStudio ? STUDIO_FOOTER_LINKS : FOOTER_LINKS

  return (
    <div
      className={classNames(styles.linksContainer, {
        [styles.linksContainerStudio]: isStudio,
      })}
      data-type='links-container'
    >
      {links.map(({ title, links }) => (
        <div
          className={classNames(styles.linksBox, {
            [styles.linksBoxStudio]: isStudio,
          })}
          key={title}
        >
          <span
            className={classNames('defaultTypographyH6', {
              [styles.studioText]: isStudio,
            })}
          >
            {title}
          </span>
          {links.map(({ title: linkTitle, url, icon }) => {
            if (url === REQUEST_SUPPORT_URL) {
              return (
                <RequestSupportModal
                  key={`${title}-${linkTitle}`}
                  triggerClassName='defaultTypographyXSmall'
                />
              )
            }

            const isAnotherDomain = url.includes('http')

            return (
              <SALink
                key={`${title}-${linkTitle}`}
                href={url}
                data-gtm-event='footer'
                rel={isAnotherDomain ? 'noopener noreferrer' : undefined}
                target={isAnotherDomain ? '_blank' : ''}
                className={classNames('defaultTypographyXSmall', {
                  [styles.studioLink]: isStudio,
                })}
              >
                {!!icon && ICONS_MAP[icon]}
                {linkTitle}
              </SALink>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default FooterLinks
